import { Path } from '@enums/path';

const subPath = 'signup';

export const Paths = {
  [Path.PoCwpSelection]: `${subPath}`,
  [Path.PolicyTypeSelection]: `${subPath}/${Path.PolicyTypeSelection}`,
  [Path.PolicyInfoInput]: `${subPath}/${Path.PolicyInfoInput}`,
  [Path.ReviewInformation]: `${subPath}/${Path.ReviewInformation}`,
  [Path.SelectUsername]: `${subPath}/${Path.SelectUsername}`,
  [Path.InputUsername]: `${subPath}/${Path.InputUsername}`,
  [Path.InputOtp]: `${subPath}/${Path.InputOtp}`,
  [Path.SetPassword]: `${subPath}/${Path.SetPassword}`,
  [Path.Success]: `${subPath}/${Path.Success}`,
  [Path.Error]: `${subPath}/${Path.Error}`,
};
